module.exports = __webpack_public_path__ + "statics/img/11.b3802c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/11.png
// module id = R74N
// module chunks = 1